export enum ESavingPlan {
    weekly = 'Weekly',
    biweekly = 'Bi-Weekly',
    monthly = 'Monthly',
}
